import React, { useEffect, useState } from "react";
import { Activity, Mail, ShieldCheck, Radar } from "lucide-react";

export default function TelemetryHero() {
  const [t, setT] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setT((n) => n + 1), 1600);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative" data-testid="telemetry-hero">
      {/* Floating cards composition */}
      <div className="relative max-w-md mx-auto">
        {/* Main card */}
        <div className="panel-shadow p-6">
          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-2">
              <span className="pulse-dot"></span>
              <span className="text-xs font-medium ink-soft">acme-demo.io</span>
            </div>
            <span className="chip chip-success">verified</span>
          </div>
          <div className="text-xs label-mono mb-1">Domain Trust Score</div>
          <div className="flex items-baseline gap-2">
            <div className="text-5xl font-display font-bold ink">{92 - (t % 4)}</div>
            <div className="text-sm text-emerald-700 font-medium">+4 this week</div>
          </div>
          {/* Mini sparkline */}
          <svg viewBox="0 0 280 60" className="w-full h-12 mt-4">
            <defs>
              <linearGradient id="hg" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#FF5C1F" stopOpacity="0.25" />
                <stop offset="100%" stopColor="#FF5C1F" stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              d="M0 45 L40 38 L80 42 L120 28 L160 32 L200 18 L240 22 L280 10 L280 60 L0 60 Z"
              fill="url(#hg)"
            />
            <path
              d="M0 45 L40 38 L80 42 L120 28 L160 32 L200 18 L240 22 L280 10"
              stroke="#FF5C1F"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="mt-4 grid grid-cols-3 gap-2 text-center">
            {[["DMARC", 97, "%"], ["SPF", 88, "%"], ["DKIM", 94, "%"]].map(([l, v, s]) => (
              <div key={l} className="panel-soft py-2.5">
                <div className="text-[10px] ink-muted uppercase tracking-wider font-medium">{l}</div>
                <div className="text-sm font-display font-bold ink">{v}{s}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Activity card overlapping */}
        <div className="panel-shadow p-5 absolute -bottom-10 -left-10 w-72 hidden sm:block">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs font-semibold ink">Live activity</div>
            <span className="pulse-dot"></span>
          </div>
          <div className="space-y-2.5">
            {[
              { Icon: ShieldCheck, c: "text-emerald-700", t: "DMARC alignment ok", s: "sendgrid.net" },
              { Icon: Radar, c: "text-orange-600", t: "New sender discovered", s: "intercom.io" },
              { Icon: Mail, c: "text-amber-700", t: "SPF lookup limit warning", s: "hubspot.com" },
            ].map((row, i) => (
              <div key={i} className="flex items-start gap-2.5" style={{ opacity: i === (t % 3) ? 1 : 0.55 }}>
                <div className="h-7 w-7 rounded-full bg-stone-100 flex items-center justify-center shrink-0">
                  <row.Icon className={`h-3.5 w-3.5 ${row.c}`} strokeWidth={2} />
                </div>
                <div className="min-w-0">
                  <div className="text-xs ink font-medium truncate">{row.t}</div>
                  <div className="text-[10px] ink-muted font-mono truncate">{row.s}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sender chip stack */}
        <div className="panel-shadow px-4 py-3 absolute -top-6 -right-6 hidden md:block">
          <div className="text-[10px] ink-muted uppercase tracking-wider font-medium mb-1.5">Senders</div>
          <div className="flex items-center gap-1.5">
            {["S", "M", "H", "I", "+"].map((c, i) => (
              <div
                key={i}
                className="h-7 w-7 rounded-full border-2 border-white flex items-center justify-center text-[10px] font-bold"
                style={{
                  background: i === 4 ? "#1A1714" : ["#FF5C1F", "#2E7D5B", "#B45309", "#6366F1"][i],
                  color: "#fff",
                  marginLeft: i === 0 ? 0 : -10,
                }}
              >
                {c}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
